import {Flyout_ImageContainer_FlyoutSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {SectionFooter, SectionHeadline} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useTrackFlyoutOriginClick} from '../../../hooks/useOriginClickTrackingFunction';
import {ImageSectionItem} from './ImageSectionItem';

export const ImageSection: React.FC<Flyout_ImageContainer_FlyoutSection> = ({
  headline,
  items,
  footer,
}) => {
  const trackOriginClick = useTrackFlyoutOriginClick();
  const ImageWrapper = getImageWrapper(items.length);
  return (
    <ImageSectionWrapper
      data-testid={
        headline ? `imageSectionWrapper-${headline}` : 'imageSectionWrapper'
      }
    >
      <SectionHeadline label={headline} />
      <ImageWrapper>
        {items.map((item, index) => (
          <ImageSectionItem
            key={index}
            item={item}
            streamPosition={index}
            itemsAmount={items.length}
          />
        ))}
      </ImageWrapper>
      {footer && (
        <SectionFooter
          dataTestId="imageSectionFooter"
          onLinkItemClick={trackOriginClick}
          label={footer.label}
          url={footer.url.url}
        />
      )}
    </ImageSectionWrapper>
  );
};

const ImageSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
`;

const getImageWrapper = (count: number) => {
  switch (count) {
    case 5:
      return ThreeColsTwoRowsWithBASItemsWrapper;
    case 6:
      return ThreeColsTwoRowsItemsWrapper;
    case 7:
    case 8:
      return FourColsThreeRowsItemsWrapper;
    default:
      return ImageSectionItemsWrapper;
  }
};

const ImageSectionItemsWrapper = styled.div`
  display: flex;
  gap: 10px;
  overflow: hidden;
  width: fit-content;
  max-height: 254px;
`;

const ThreeColsTwoRowsItemsWrapper = styled(ImageSectionItemsWrapper)`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, auto);
`;

/*
 * This is only used to show the BAS image within the sports flyout.
 * Since the BAS imageTeaser is the last element within the image container section array,
 * we need to move it to the third position to make it works according the design.
 */
const ThreeColsTwoRowsWithBASItemsWrapper = styled(
  ThreeColsTwoRowsItemsWrapper,
)`
  & > *:nth-child(5) {
    order: 3;
    grid-row: span 2;
  }

  & > *:nth-child(3) {
    order: 4;
  }

  & > *:nth-child(4) {
    order: 5;
  }
`;

const FourColsThreeRowsItemsWrapper = styled(ThreeColsTwoRowsItemsWrapper)`
  grid-template-columns: repeat(4, auto);
  grid-template-rows: repeat(3, auto);
`;
